import { render, staticRenderFns } from "./jJoin.vue?vue&type=template&id=6109c794&scoped=true"
import script from "./jJoin.vue?vue&type=script&lang=js"
export * from "./jJoin.vue?vue&type=script&lang=js"
import style0 from "./jJoin.vue?vue&type=style&index=0&id=6109c794&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6109c794",
  null
  
)

export default component.exports